export default "__VITE_ASSET__d944ae5c__"